import { SVGProps } from "react";

const Camera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.75 4.75049C4.52936 4.75415 3.85383 4.78335 3.29873 5.01634C2.5212 5.34269 1.88801 5.94552 1.51811 6.71158C1.21618 7.33687 1.16677 8.13799 1.06796 9.74023L0.913115 12.2509C0.667385 16.2353 0.54452 18.2275 1.71369 19.4888C2.88285 20.75 4.85252 20.75 8.79187 20.75H12.7081C16.6475 20.75 18.6172 20.75 19.7863 19.4888C20.9555 18.2275 20.8326 16.2353 20.5869 12.2509L20.432 9.74023C20.3332 8.13799 20.2838 7.33687 19.9819 6.71158C19.612 5.94552 18.9788 5.34269 18.2013 5.01634C17.6462 4.78335 16.9706 4.75415 15.75 4.75049"
      stroke={props.stroke || "#626262"}
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M15.75 5.75L14.8642 3.53543C14.482 2.57996 14.1494 1.4961 13.1666 1.00955C12.6424 0.75 12.0116 0.75 10.75 0.75C9.4884 0.75 8.8576 0.75 8.33335 1.00955C7.3506 1.4961 7.01801 2.57996 6.63583 3.53543L5.75 5.75"
      stroke={props.stroke || "#626262"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.25 12.75C14.25 14.683 12.683 16.25 10.75 16.25C8.817 16.25 7.25 14.683 7.25 12.75C7.25 10.817 8.817 9.25 10.75 9.25C12.683 9.25 14.25 10.817 14.25 12.75Z"
      stroke="#141B34"
      stroke-width="1.5"
    />
    <path
      d="M10.7498 4.75H10.7588"
      stroke="#141B34"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default Camera;
